/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!**************************************!*\
  !*** ./adssources/js/back_to_top.js ***!
  \**************************************/
(function () {
  function trackScroll() {
    var scrolled = window.pageYOffset;
    var coords = 300;

    if (scrolled > coords) {
      goTopBtn.classList.remove("hide_button");
    }

    if (scrolled < coords) {
      goTopBtn.classList.add("hide_button");
    }
  }

  function backToTop() {
    if (window.pageYOffset > 0) {
      window.scrollBy(0, -80);
      setTimeout(backToTop, 0);
    }
  }

  var goTopBtn = document.querySelector(".back-to-top");
  window.addEventListener("scroll", trackScroll);
  goTopBtn.addEventListener("click", backToTop);
})();
/******/ })()
;